import React,
{
	// useState
} from 'react'

function PlayComPlanCardMolDetailEmpty(props) {

	return (
		<div className="c25CompPlanCardsFeaturesListSld">
			<div className="dtSpecial">
				<p>
					<strong>&nbsp;</strong>
					<span>&nbsp;</span>
				</p>
			</div>
			<dl>
				<dt>&nbsp;</dt>
				<dd>&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd>&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd>&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd>&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd className="rs">&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd>&nbsp;</dd>
			</dl>
			<dl>
				<dt>&nbsp;</dt>
				<dd className="include">&nbsp;</dd>
			</dl>
		</div>
	)
}

export default PlayComPlanCardMolDetailEmpty
